import { AccountCategory, Checklist } from ".";
import { MasterTaskType } from "./enums/mastertasktype";

export class MasterTask {
    masterTaskId: number;
    accountCategoryId: number;
    accountCategory: AccountCategory;
    taskName: string;
    floatDays: number;
    duration: number;
    buildQualityStep?: number | null;
    earlyPaymentTrigger: number;
    scheduleType: string;
    masterTaskType: MasterTaskType;
    checklist: Checklist[];
    hasChecklists: boolean;
    isActive: boolean;
    accountCategoryNumber: string;
    isSelected: boolean;
}
